import Vue from 'vue';
import Vuex from 'vuex';
import countApi from '../api/count-api';
import AlarmApi from '@/api/alarm-api';

const PAGE_LIMIT_CNT = 20;

Vue.use(Vuex);

const initialState = () => {
  return {
    notificationInfo: {
      count: 0,
      list: [],
      isCountApiStop: false,
      pendingFlag: false,
      nid: null,
    },
  };
};

const getQueryParams = (targetQuery, responseObject) => {
  const obj = {};
  for (const key in responseObject) {
    obj[`${targetQuery}[${key}]`] = responseObject[key];
  }
  return obj;
};

const getMutiQueryParams = (targetQueryDepth1, targetQueryDepth2, responseObject) => {
  const obj = {};
  for (const key in responseObject) {
    obj[`${targetQueryDepth1}[${targetQueryDepth2}][${key}]`] = responseObject[key];
  }
  return obj;
};

//! 기존 php 로직 가져옴
const convertResourcePath = (item) => {
  // [예외] 인사 - 경력증명서 승인
  if (item.solution === 'hr' && item.action === 'cert') {
    return `${process.env['VUE_APP_OFFICE_HR_URL']}/my-certificate`;
  }

  // [예외] 인사 관리자 - 경력증명서 요청
  if (item.solution === 'hr-admin' && item.action === 'cert') {
    return `${process.env['VUE_APP_OFFICE_HR_ADMINS_URL']}/certificates-history`;
  }

  // [예외] 계정 차단
  if (item.solution === 'admin' && item.action === 'receive') {
    return `${process.env['VUE_APP_OFFICE_ADMINS_URL']}` + item.endpoint.resource_path;
  }

  if (item.solution === 'office-rel' && item.action === 'create') {
    return `${process.env['VUE_APP_OFFICE_ADMINS_URL']}` + item.endpoint.resource_path;
  }

  // [예외] 파일 감염
  if (item.action === 'infected') {
    return process.env['VUE_APP_OFFICE_' + item.solution.toUpperCase() + '_URL'] + item.endpoint.resource_path;
  }

  // [예외] 조직개편 & 인사발령
  if (item.solution === 'hr-admin' && item.action === 'transfer') {
    return `${process.env['VUE_APP_OFFICE_HR_ADMINS_URL']}${item.endpoint.resource_path}`;
  }

  const solutionArr = ['ea', 'shared', 'schedule'];
  const domain = item.endpoint.domain;

  if (solutionArr.includes(item.solution)) {
    item.endpoint.resource_path = `${process.env['VUE_APP_OFFICE_' + item.solution.toUpperCase() + '_URL']}/${domain}${
      item.endpoint.resource_path
    }`;
  } else if (item.solution === 'bbs') {
    item.endpoint.resource_path = item.endpoint.resource_path.replace(/\/board\/bbs/g, '/bbs/board'); // 잘못된 링크 수정

    const forumBaseUrl = process.env['VUE_APP_OFFICE_FORUM_URL'];
    if (item.action === 'reject') {
      // action reject 일때 alarm-api 포맷에서 쿼리스트링이 중복으로 들어감. 반려는 내 게시물로의 접근만 가능
      const query = '?boardList=mine&type=approval';
      const [base] = item.endpoint.resource_path.split(query);
      item.endpoint.resource_path = `${forumBaseUrl}${base}${query}`;
      return item.endpoint.resource_path;
    } else if (item.action !== 'create') {
      item.endpoint.resource_path = `${forumBaseUrl}${item.endpoint.resource_path}`;
      return item.endpoint.resource_path;
    }

    if (item.alarm_type === 'A') {
      //! 맴버 게시판 초대
      item.endpoint.resource_path = item.endpoint.resource_path.replace(/board_view/g, 'board_list');
      item.endpoint.resource_path = item.endpoint.resource_path.replace(/\/0/g, '');
    }
    item.endpoint.resource_path = `${process.env['VUE_APP_OFFICE_' + item.solution.toUpperCase() + '_URL']}/${domain}${
      item.endpoint.resource_path
    }`;
  } else if (item.solution === 'group' && item.endpoint.messenger_link.split('/').length === 8) {
    const groupId = item.endpoint.messenger_link.split('/')[6];
    const cardId = item.endpoint.messenger_link.split('/')[7];
    item.endpoint.resource_path = `${process.env['VUE_APP_OFFICE_URL']}/${domain}/common/redirect/group_card/${groupId}/${cardId}`;
  } else if (item.solution === 'drive') {
    const nodeId = item.endpoint.messenger_link.split('/')[6];

    // [예외] 드라이브 - 관리자 권한 부여 또는 공용폴더 상세인경우 endpoint.resource_path로 이동
    if (item.action === 'addAdmin' || item.action === 'delComDir') {
      item.endpoint.resource_path = `${process.env['VUE_APP_OFFICE_DRIVE_URL']}${item.endpoint.resource_path}`;
      return item.endpoint.resource_path;
    }

    item.endpoint.resource_path = `${process.env['VUE_APP_OFFICE_DRIVE_URL']}${item.endpoint.resource_path}/nodes/${nodeId}`;
  } else if (item.solution === 'hr') {
    item.endpoint.resource_path = `${process.env['VUE_APP_OFFICE_HR_URL']}${item.endpoint.resource_path}`;
  } else if (item.solution === 'hr-admin') {
    item.endpoint.resource_path = `${process.env['VUE_APP_OFFICE_HR_ADMIN_URL']}${item.endpoint.resource_path}`;
  } else if (item.solution === 'task') {
    item.endpoint.resource_path = `${process.env['VUE_APP_OFFICE_TASK_URL']}${item.endpoint.resource_path.slice(5)}`;
  } else if (item.solution === 'sales') {
    try {
      item.endpoint.resource_path = `${atob(item.endpoint.resource_path || '')}`;
    } catch (error) {
      console.error('디코딩 값이 올바르지 않습니다.');
    }
  } else if (item.solution === 'login-log') {
    item.endpoint.resource_path = `${process.env['VUE_APP_OFFICE_MYPAGE_URL']}${item.endpoint.resource_path}`;
  } else {
    item.endpoint.resource_path = `${process.env['VUE_APP_OFFICE_URL']}/${domain}${item.endpoint.resource_path}`;
  }

  return item.endpoint.resource_path;
};

const convertUnicode = (content) => {
  return content
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&qpos;/g, "'");
};

const convertContent = (item) => {
  const startOfText = '\u0002';

  return item.content.split(startOfText).map(convertUnicode);
};

const getters = {
  getCount(state) {
    return state.notificationInfo.count;
  },
  getList(state) {
    return state.notificationInfo.list;
  },
};

const mutations = {
  setCount(state, count) {
    state.notificationInfo.count = count;
  },
  setList(state, list) {
    state.notificationInfo.list = list;
  },
  setIsCountApiStop(state, booleanFlag) {
    state.notificationInfo.isCountApiStop = booleanFlag;
  },
  setPendingFlag(state, booleanFlag) {
    state.notificationInfo.pendingFlag = booleanFlag;
  },
  setNid(state, nid) {
    state.notificationInfo.nid = nid;
  },
  setRead(state, id) {
    let notificationIndex = state.notificationInfo.list.findIndex((notificationInfo) => {
      return notificationInfo.id === id;
    });

    state.notificationInfo.list[notificationIndex]['read'] = 2;
  },
  setReadAll(state) {
    state.notificationInfo.list.forEach((notificationInfo) => {
      notificationInfo['read'] = 2;
    });
  },
};

const actions = {
  async loadCount({ commit }) {
    return new Promise((resolve) => {
      commit('setCount', 0);
      countApi
        .loadNotificationCount()
        .then((apiResponse) => {
          let count = apiResponse.data.data.unread;
          commit('setCount', count);
        })
        .catch((error) => {
          console.log(error);
          commit('setIsCountApiStop', true); //! api 중지
        })
        .finally(() => {
          resolve();
        });
    });
  },
  async loadCountRefresh({ commit }) {
    return new Promise((resolve) => {
      commit('setCount', 0);
      countApi
        .loadNotificationCountRefresh()
        .then((apiResponse) => {
          let count = apiResponse.data.data.unread;
          commit('setCount', count);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          resolve();
        });
    });
  },

  async loadList({ commit, state }) {
    try {
      if (state.notificationInfo.pendingFlag) {
        //! 스크롤 최하단으로 내릴시 debounce 와 같은 효과를 내기 위함
        return;
      }

      if (state.notificationInfo.list.length > 0 && state.notificationInfo.list.length < PAGE_LIMIT_CNT) {
        //! 알람이 PAGE_LIMIT_CNT 미만인경우 스크롤을 내려도 api call을 하지 않는다.
        return;
      }

      commit('setPendingFlag', true);
      const params = !state.notificationInfo.nid
        ? { ...getQueryParams('filter', { type: 'office' }), ...getQueryParams('page', { limit: PAGE_LIMIT_CNT }) }
        : {
            ...getMutiQueryParams('filter', 'id', { lt: state.notificationInfo.nid }),
            ...getQueryParams('filter', { type: 'office' }),
            ...getQueryParams('page', { limit: PAGE_LIMIT_CNT }),
          };
      const result = await AlarmApi.loadAlarmList({ params });

      if (result.status === 200) {
        commit('setCount', 0);
        if (result.data.data) {
          let convertedResult = result.data.data.map((item) => {
            return {
              ...item,
              message: convertContent(item),
              endpoint: {
                resource_path: convertResourcePath(item),
              },
            };
          });

          convertedResult = [...state.notificationInfo.list, ...convertedResult];
          commit('setList', convertedResult);
          commit('setNid', convertedResult[convertedResult.length - 1].id);
          commit('setPendingFlag', false);
        }
      }
    } catch (error) {
      console.log(error);
    }
  },
  async read({ commit }, { id, params }) {
    return new Promise((resolve) => {
      AlarmApi.readAlarm(id, params)
        .then(() => {
          commit('setRead', id);
        })
        .finally(() => {
          resolve();
        });
    });
  },
  async readAll({ commit, state }) {
    return new Promise((resolve) => {
      AlarmApi.readAlarm(state.notificationInfo.nid, { range: 'gte', type: 'office' })
        .then(() => {
          commit('setReadAll');
        })
        .finally(() => {
          resolve();
        });
    });
  },
  closeNotiPopover({ commit }, id) {
    commit('setNid', id);
    commit('setList', []);
  },
};

export default {
  namespaced: true,
  state: initialState,
  mutations,
  actions,
  getters,
  strict: process.env.NODE_ENV !== 'production',
};
